module.exports = __webpack_public_path__ + "static/media/122.5d630538.mp3";